import { SupportedLanguage } from '@pmi.web/localization';
import { ReactNode, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18nInstance } from '../services/translations';

interface ITranslatableProps {
  readonly language: SupportedLanguage;
  readonly children: ReactNode;
}

export function Translatable(props: ITranslatableProps) {
  useEffect(() => {
    if (props.language) {
      i18nInstance.changeLanguage(props.language);
    }
  }, [props.language]);

  return (
    <I18nextProvider i18n={i18nInstance}>{props.children}</I18nextProvider>
  );
}
